import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavMenuService {
  private readonly menuCollapsed = signal(true);
  readonly isMenuCollapsed = this.menuCollapsed.asReadonly();

  toggle(): boolean {
    this.menuCollapsed.update(value => !value);
    return this.menuCollapsed();
  }

  open(): void {
    this.menuCollapsed.set(false);
  }

  close(): void {
    this.menuCollapsed.set(true);
  }

  setCollapsed(isCollapsed: boolean): void {
    this.menuCollapsed.set(isCollapsed);
  }
}
